/**
 * Helper function for checking if a primitive / reference is empty.
 * @param {*} obj
 * @returns
 */
function isEmpty(obj: Object | string | null): boolean {
  // checks for empty object
  if (typeof obj === 'object' && obj !== null) {
    return Object.keys(obj).length === 0;
  }

  // checks for nullable value
  if (obj === null) return true;

  // checks for empty string
  if (typeof obj === 'string') {
    return obj === '';
  }

  return false;
}

export default isEmpty;
